import React from 'react';
import styled from 'styled-components';
import { GapContainer } from '../../fundamentals/spaces/SpaceContainer';
import { LoadingAnimation, LoadingAnimationLabelPosition, LoadingAnimationSize } from '../../components/LoadingAnimation/LoadingAnimation';
import { Logo, LogoSize } from '../../components/Logo/Logo';

const SplashScreenContainer = styled(GapContainer)`
  background-color: ${({ theme }) => `${theme.colours.eoraCoreColours.BACKGROUND_COLOR.APPLICATION_BGS.APPBODY_COLOR_BACKGROUND};`}
  width: 100%;
  min-height: 100vh;
  justify-content: center;
`;

export interface ISplashScreenProps {
  label?: string;
  logoSize?: LogoSize;
  labelPosition?: LoadingAnimationLabelPosition;
  loaderSize?: LoadingAnimationSize;
}

export const SplashScreen: React.FC<ISplashScreenProps> = ({ label, logoSize, labelPosition, loaderSize }) => {
  return (
    <SplashScreenContainer gap={48} column alignItems='center'>
      <Logo placement='header' size={logoSize} />
      <LoadingAnimation label={label || ``} labelPosition={labelPosition} size={loaderSize} />
    </SplashScreenContainer>
  );
};
